import { OrganizationVariable } from "../../redux/reducers/organizationVariablesSlice";
import { VariablesForm } from "../VariablesForm";
import { OrganizationSettingsTab } from "./OrganizationSettingTab";

type GlobalVariablesCardProps = {
  variables: OrganizationVariable[];
  isLoading?: boolean;
  onChange: (updatedVariable: Partial<OrganizationVariable>) => void;
  onClickAdd: () => void;
  onClickDelete: (id: string) => Promise<void>;
  className?: string;
};

export const GlobalVariablesCard = ({ variables, onChange, onClickAdd, onClickDelete }: GlobalVariablesCardProps) => {
  return (
    <OrganizationSettingsTab
      title="Global Variables"
      description="Manage global variables for your organization"
      onClickAction={onClickAdd}
      actionLabel="Add Variable"
    >
      <VariablesForm
        variables={variables}
        onChange={onChange}
        onClickAdd={onClickAdd}
        onClickDelete={onClickDelete}
      />
    </OrganizationSettingsTab>
  );
};
